<p-confirmDialog 
[acceptIcon]="yesIcon"
[rejectIcon]="noIcon"
[style]="style"
> </p-confirmDialog>
